export const pictogramSizeMap = {
  sm: '96px',
  md: '128px'
};
export const pictogramSizeArray = Object.keys(pictogramSizeMap);